/**
 * Restricts access to route for selected countries.
 * Works only in prod.
 */

import React, { ReactElement } from "react";

import { IS_BROWSER, IS_PROD } from "@config/consts";

import { AVAILABLE_COUNTRIES } from "@typings/globals";

import { langFromPathname } from "@services/LangFromPathname";

import { useLocalisation } from "@hooks/useLocalisation";

interface Props {
  children: React.ReactNode;
  whitelist: AVAILABLE_COUNTRIES[];
}

const CountryGuard = (props: Props): ReactElement | null => {
  const { language, country } = useLocalisation();

  const isCountryRestirected = !props.whitelist.includes(country);

  React.useEffect(() => {
    if (IS_BROWSER && IS_PROD && isCountryRestirected) {
      window.location.href = `/${language || langFromPathname()}`;
    }
  }, []);

  return <React.Fragment>{props.children}</React.Fragment>;
};

export { CountryGuard };

CountryGuard.displayName = "CountryGuard";
